module.exports = __webpack_public_path__ + "static/media/pen.af9fdec2.png";